// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2fMQq","fileBtn":"File_fileBtn__1uyGd","closeBtn":"File_closeBtn__3N4Ha","fileSelected":"File_fileSelected__3r54W","disabled":"File_disabled__130_h"};